import { render, staticRenderFns } from "./headerFundacion.vue?vue&type=template&id=42fe01da&"
import script from "./headerFundacion.vue?vue&type=script&lang=js&"
export * from "./headerFundacion.vue?vue&type=script&lang=js&"
import style0 from "./headerFundacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports